import Maps from "./ClassMaps";
import L from "leaflet";

// Map Proposition Init
const map = document.querySelector('[data-class="osm_map"]')

if (map) {
    const lng = map.getAttribute('data-lng')
    const lat = map.getAttribute('data-lat')
    const zoom = map.getAttribute('data-zoom')
    const tileLayer = map.getAttribute('data-type')

    const markerToSave = document.querySelector('[data-key="markerToSave"]')
    const addressGroup = document.querySelector('[data-key="addressGroup"]')

// Init the Maps Class

    const Map = new Maps(map.attributes.id.nodeValue, lng, lat, zoom, tileLayer)

// Init the Map
    Map.init

// Get bounds at inib
    const bounds = Map.map.getBounds()
// Make translation
    Map.doTranslation()

// Add the control to the map
    Map.control

    function setMarkerToSave(value) {
        markerToSave.value = value
    }

    Map.map.on(L.Draw.Event.CREATED, (e) => {
        const markerMap = Map.markerMap(e.layer._latlng.lat, e.layer._latlng.lng);
        let geoJSON = Map.createElement(markerMap)

        setMarkerToSave(geoJSON)

        Map.queryAddressByLatLng(e.layer._latlng, addressGroup)
        // Reset Geolocation if active
        let geoLocate = document.querySelector('.leaflet-control-locate')
        if (geoLocate.classList.contains('active')) {
            let click = new Event('click');
            geoLocate.querySelector('a').dispatchEvent(click)
        }
    })

    function onLocationFound(e) {
        const markerMap = Map.markerMap(e.latlng.lat, e.latlng.lng);
        let geoJSON = Map.createElement(markerMap)
        setMarkerToSave(geoJSON)
        Map.queryAddressByLatLng(e.latlng, addressGroup)
    }

    Map.map.on('locationfound', onLocationFound);

    Map.map.on('geosearch/showlocation', function (e) {
        let latlng = {lat: e.location.y, lng: e.location.x}
        const markerMap = Map.markerMap(e.location.y, e.location.x);
        let geoJSON = Map.createElement(markerMap)
        setMarkerToSave(geoJSON)
        Map.queryAddressByLatLng(latlng, addressGroup)
        // Reset Geolocation if active
        let geoLocate = document.querySelector('.leaflet-control-locate')
        if (geoLocate.classList.contains('active')) {
            let click = new Event('click');
            geoLocate.querySelector('a').dispatchEvent(click)
        }
    })
}

function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('../', true, /\.(png|jpe?g|gif|svg)$/));
